import React, { useMemo, useCallback } from 'react';
import { useLiveVotingSessions } from '../../../../../../data/hooks/voting/useLiveVotingSessions';
import Link from '../../../../../elements/Link';
import Icon from '../../../../../elements/icons/Icon';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';

function ScheduleItemVote(props) {
    const { event, session } = props,
        voteIds = useMemo(
            () => session?.vote_ids ?? (session?.vote_id ? [session.vote_id] : []),
            [session?.vote_ids, session?.vote_id]
        ),
        filter = useCallback((v) => voteIds.includes(v.id) && v.is_open, [voteIds]),
        openVoting = useLiveVotingSessions(event.id, { filter })[0],
        i18n = useI18n();

    if (!voteIds.length) return null;

    return (
        <div
            style={{
                backgroundColor: event.settings.secondary_color,
                padding: 10,
                opacity: openVoting ? 1 : 0.4,
            }}>
            <Link
                href={openVoting ? `./livevoting/${openVoting.id}` : undefined}
                style={{
                    backgroundColor: event.settings.primary_color,
                }}>
                <div className="text-center">
                    <Icon src={'img/vote_icon.png'} size={22} />
                    <div style={{ color: 'white', marginTop: 10 }}>{event.settings.vote_label || i18n['label.vote']}</div>
                </div>
            </Link>
        </div>
    );
}

export default ScheduleItemVote;
